<div class="invoice-details-view-container" *ngIf="invoiceObject" fxLayout="column" fxLayoutGap="15px">
  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + invoiceObject?.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="invoiceObject?.status?.name">
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button
      [disabled]="!(userPermissions | async).settlement.read"
      (click)="downloadPdf()"
      mat-stroked-button
    >
      <mat-icon>download</mat-icon>
      <span> PDF</span></button>

    <button
      [disabled]="!(userPermissions | async).settlement.write"
      *ngIf="[INVOICE_STATUS_SUSPENDED, INVOICE_STATUS_TO_BE_CORRECTED, INVOICE_STATUS_SENT_FOR_PAYMENT ].includes(invoiceObject?.status.key)"
      (click)="changeStatus('changeToToBeRealized', false, '', 'Do zrealizowania')"
      mat-stroked-button
    ><span>Do zrealizowania</span></button>

    <button
      [disabled]="!(userPermissions | async).settlement.write"
      *ngIf="[INVOICE_STATUS_TO_BE_REALIZED].includes(invoiceObject?.status.key) || (userPermissions | async).settlement.admin_root"
      (click)="modify()"
      mat-stroked-button
    ><span>Edytuj</span></button>

    <button
      [disabled]="!(userPermissions | async).settlement.write"
      *ngIf="[INVOICE_STATUS_TO_BE_REALIZED, INVOICE_STATUS_SENT_FOR_PAYMENT].includes(invoiceObject?.status.key)"
      (click)="changeStatus('changeToPaid', false, '', 'Zapłacona')"
      mat-stroked-button
    ><span>Zapłacona</span></button>

    <button
      [disabled]="!(userPermissions | async).settlement.write"
      *ngIf="[INVOICE_STATUS_TO_BE_REALIZED].includes(invoiceObject?.status.key)"
      (click)="changeStatus('changeToSuspended', true, 'Powód wstrzymania', 'Wstrzymana')"
      mat-stroked-button
    ><span>Wstrzymana</span></button>

    <button
      [disabled]="!(userPermissions | async).settlement.write"
      *ngIf="[INVOICE_STATUS_TO_BE_REALIZED].includes(invoiceObject?.status.key)"
      (click)="changeStatus('changeToRejected', true, 'Powód odrzucenia', 'Odrzucona')"
      mat-stroked-button
    ><span>Odrzucona</span></button>

    <button
      [disabled]="!(userPermissions | async).settlement.write"
      *ngIf="[INVOICE_STATUS_TO_BE_REALIZED].includes(invoiceObject?.status.key)"
      (click)="changeStatus('changeToToBeCorrected', true, 'Dane do korekty', 'Do korekty')"
      mat-stroked-button
    ><span>Do korekty</span></button>

<!--    <button-->
<!--      [disabled]="!(userPermissions | async).settlement.write || [INVOICE_STATUS_SENT_FOR_PAYMENT, INVOICE_STATUS_REJECTED].includes(invoiceObject?.status.key) || [INVOICE_STATUS_PAID].includes(invoiceObject?.status.key)"-->
<!--      (click)="addDocument()"-->
<!--      *ngIf="![INVOICE_STATUS_REJECTED].includes(invoiceObject?.status.key)"-->
<!--      mat-stroked-button color="primary"-->
<!--    >
      <mat-icon>add</mat-icon>
      <span>Dodaj notę</span></button>-->

    <!--    <button-->
    <!--      *ngIf="!invoiceObject.selfBilling && ![INVOICE_STATUS_REJECTED].includes(invoiceObject.status.key)"-->
    <!--      [disabled]="!(userPermissions | async).settlement.delete || [INVOICE_STATUS_SENT_FOR_PAYMENT, INVOICE_STATUS_REJECTED].includes(invoiceObject.status.key) || [INVOICE_STATUS_PAID].includes(invoiceObject.status.key)"-->
    <!--      (click)="delete()" mat-stroked-button color="warn"-->
    <!--    ><mat-icon>delete</mat-icon> <span> Usuń</span></button>-->
    <button
      *ngIf="(!invoiceObject.selfBilling || (userPermissions | async).settlement.admin_root) && ![INVOICE_STATUS_REJECTED].includes(invoiceObject?.status.key)"
      [disabled]="!(userPermissions | async).settlement.delete || [INVOICE_STATUS_SENT_FOR_PAYMENT, INVOICE_STATUS_REJECTED].includes(invoiceObject?.status.key) || [INVOICE_STATUS_PAID].includes(invoiceObject?.status.key)"
      (click)="delete()" mat-stroked-button color="warn"
    >
      <mat-icon>delete</mat-icon>
      <span> Usuń</span></button>
  </div>

  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane faktury</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Miesiąc rozliczeniowy" [value]="invoiceObject?.billingMonth"></app-detail>

              <app-detail fxFlex="50" header="Numer" [value]="invoiceObject?.number"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail
                fxFlex="50"
                [header]="invoiceObject?.mandateBill || !invoiceObject.partner ? 'Kwota faktury (brutto)' : 'Kwota faktury'"
              >
                <ng-container *ngIf="invoiceObject?.mandateBill">
                  {{ (invoiceObject.gross === null ? 0 : invoiceObject.gross) | number:'1.2-2' }} zł
                </ng-container>

                <ng-container *ngIf="!invoiceObject?.mandateBill && invoiceObject.partner">
                  {{ (invoiceObject.net === null ? 0 : invoiceObject.net) | number:'1.2-2' }} zł
                </ng-container>

                <ng-container *ngIf="!invoiceObject?.mandateBill && !invoiceObject.partner">
                  {{ (invoiceObject.gross === null ? 0 : invoiceObject.gross) | number:'1.2-2' }} zł
                </ng-container>
              </app-detail>
              <app-detail
                fxFlex="50" header="Kwota do wypłaty"
              >
                {{ (invoiceObject.payoutNet === null ? 0 : invoiceObject.payoutNet) | number:'1.2-2' }} zł
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Data wystawienia" [value]="invoiceObject.issueDate | date:'y-MM-dd'"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Miesiąc sprzedaży" [value]="serviceDate | date:'y-MM'"></app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="50" header="Samofakturowanie"
                               [value]="invoiceObject.selfBilling"></app-detail-bool>
              <app-detail-bool fxFlex="50" header="Automatyczne rozliczanie"
                               [value]="invoiceObject.automaticSettlement"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Uwagi" [value]="invoiceObject.note"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="invoiceObject.suspendedNote">
              <app-detail fxFlex="100" header="Powód wstrzymania" [value]="invoiceObject.suspendedNote"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="invoiceObject.rejectedNote">
              <app-detail fxFlex="100" header="Powód odrzucenia" [value]="invoiceObject.rejectedNote"></app-detail>
            </div>

            <div fxLayout="row" *ngIf="invoiceObject.toBeCorrectedNote">
              <app-detail fxFlex="100" header="Dane do korekty" [value]="invoiceObject.toBeCorrectedNote"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane sprzedawcy</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Nazwa firmy" [value]="invoiceObject.sellerCompanyName"></app-detail>

              <app-detail fxFlex="50" header="NIP" [value]="invoiceObject.sellerNip"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Ulica" [value]="invoiceObject.sellerStreet"></app-detail>

              <div fxFlex="50" fxLayout="row" fxLayoutGap="15px">
                <app-detail fxFlex="50" header="Nr budynku" [value]="invoiceObject.sellerHouseNumber"></app-detail>

                <app-detail fxFlex="50" header="Nr mieszkania"
                            [value]="invoiceObject.sellerApartmentNumber"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Poczta" [value]="invoiceObject.sellerPostCity"></app-detail>

              <app-detail fxFlex="50" header="Kod pocztowy" [value]="invoiceObject.sellerZipCode"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Miejscowość" [value]="invoiceObject.sellerCity"></app-detail>

              <app-detail fxFlex="50" header="Numer konta" [value]="invoiceObject.sellerAccountNumber"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Email" [value]="invoiceObject.sellerEmail"></app-detail>

              <app-detail fxFlex="50" header="Numer telefonu" [value]="invoiceObject.sellerPhone | phone"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Płatnik VAT" [value]="invoiceObject.vatInvoice"></app-detail-bool>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="100" header="Metoda kasowa"
                               [value]="invoiceObject.checkoutMethod"></app-detail-bool>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Umowa"
                          [value]="invoiceObject?.contract?.type.name + ' (nr: ' + invoiceObject?.contract?.number + '), '
                          + invoiceObject?.contract?.status.name"
                          [link]="invoiceObject?.contract ? ['/umowy/szczegoly', invoiceObject?.contract.uuid] : undefined">
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="invoiceObject?.partner">
              <app-detail fxFlex="50" header="Strona umowy" value="Partner"></app-detail>

              <app-detail fxFlex="50" header="Partner" [value]="invoiceObject?.partner?.shortName"
                          [link]="invoiceObject?.partner ? ['/partnerzy/szczegoly', invoiceObject?.partner?.uuid] : undefined"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="invoiceObject?.ofwca">
              <app-detail fxFlex="50" header="Strona umowy" value="OFWCA"></app-detail>

              <app-detail fxFlex="100" header="OFWCA" [value]="invoiceObject?.ofwca?.fullName"
                          [link]="['/ofwca/szczegoly', invoiceObject?.ofwca?.uuid]"></app-detail>
            </div>
            <ng-container *ngIf="invoiceObject?.contract?.contractBalance">
              <div fxLayout="row" fxLayoutGap="15px">
                <app-detail fxFlex="100" header="Saldo">
                  {{ invoiceObject?.contract?.type.name + ' (nr: ' + invoiceObject?.contract?.number + '), ' + invoiceObject?.contract?.status.name }}
                </app-detail>
              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <app-detail fxFlex="25" header="Saldo początkowe"
                            [value]=""> {{ (invoiceObject?.contract?.contractBalance.initialBalanceNet === null ? 0 : invoiceObject?.contract?.contractBalance.initialBalanceNet) | number:'1.2-2' }}
                  zł
                </app-detail>
                <app-detail fxFlex="25" header="Do wypłacenia"
                            [value]="">{{ (invoiceObject?.contract?.contractBalance.toPayNet === null ? 0 : invoiceObject?.contract?.contractBalance.toPayNet) | number:'1.2-2' }}
                  zł
                </app-detail>
                <app-detail fxFlex="25" header="Wypłacono"
                            [value]="">{{ (invoiceObject?.contract?.contractBalance.paid === null ? 0 : invoiceObject?.contract?.contractBalance.paid) | number:'1.2-2' }}
                  zł
                </app-detail>
                <app-detail fxFlex="25" header="Ogólne"
                            [value]="">{{ (invoiceObject?.contract?.contractBalance.totalCommission === null ? 0 : invoiceObject?.contract?.contractBalance.totalCommission) | number:'1.2-2' }}
                  zł
                </app-detail>
              </div>
            </ng-container>
            <!--            <div fxLayout="row" *ngFor="let invoiceSettlement of invoiceObject.settlements">-->
            <!--              <app-detail fxFlex="100" header="Rozliczenie"-->
            <!--                          [link]="['/rozliczenia/szczegoly', invoiceSettlement?.contractSettlement.commissionSettlement.uuid]">-->
            <!--                {{invoiceSettlement?.contractSettlement.commissionSettlement?.billingMonth}}-->
            <!--                - {{invoiceSettlement.net | number:'1.2-2'}} zł / {{invoiceSettlement?.contractSettlement.totalCommission | number:'1.2-2'}} zł / pozostało: {{(invoiceSettlement?.contractSettlement.leftToPayContract === null ? 0 : invoiceSettlement?.contractSettlement.leftToPayContract) | number:'1.2-2'}} zł-->
            <!--              </app-detail>-->
            <!--            </div>-->

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngFor="let document of invoiceObject.documents">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>{{ document?.type.name }}</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Numer" [value]="document?.number"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail
                fxFlex="50" header="Kwota"
              >
                {{ (document.net === null ? 0 : document.net) | number:'1.2-2' }} zł
              </app-detail>

              <div fxFlex="50">
                <app-detail header="Data wystawienia" [value]="document.issueDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Powód" [value]="document.reason"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px" *ngIf="document.fileLocation"
                 [style.margin-top]="'15px'">
              <button
                [disabled]="!(userPermissions | async).settlement.read"
                (click)="downloadDocument(document)"
                mat-stroked-button color="accent"
              >
                <mat-icon>download</mat-icon>
                <span> Pobierz dokument</span></button>

              <button
                [disabled]="!(userPermissions | async).settlement.delete"
                (click)="deleteDocument(document)"
                mat-stroked-button color="accent"
              >
                <mat-icon>delete</mat-icon>
                <span> Usuń dokument</span></button>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" *ngFor="let document of invoiceObject.noteDeductions">
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>{{document.invoiceDocument?.type.name}}</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Numer" >
                <a class="default-link" [routerLink]="['/noty/szczegoly',document?.invoiceDocument?.uuid]">
                  {{ document?.invoiceDocument?.number }}
                </a>
              </app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail
                fxFlex="50" header="Kwota"
              >
                {{(document?.invoiceDocument?.net === null ? 0 : document?.invoiceDocument?.net) | number:'1.2-2'}} zł
              </app-detail>

              <div fxFlex="50">
                <app-detail header="Data wystawienia" [value]="document?.invoiceDocument?.issueDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Powód" [value]="document.invoiceDocument?.reason"></app-detail>
            </div>

            <div fxLayout="row"  fxLayoutAlign="space-between center"  fxLayoutGap="15px" *ngIf="document.invoiceDocument?.fileLocation" [style.margin-top]="'15px'">
              <button
                [disabled]="!(userPermissions | async).settlement.read"
                (click)="downloadNoteDocument(document?.invoiceDocument.uuid)"
                mat-stroked-button color="accent"
              ><mat-icon>download</mat-icon> <span> Pobierz dokument</span></button>

<!--              <button-->
<!--                [disabled]="!(userPermissions | async).settlement.delete"-->
<!--                (click)="deleteNoteDocument(document?.invoiceDocument.uuid)"-->
<!--                mat-stroked-button color="accent"-->
<!--              ><mat-icon>delete</mat-icon> <span> Usuń dokument</span></button>-->
            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
</div>
